// Currency formatter
export const fmt = (n) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n || 0);

// Full date: "Feb 12, 2025"
export const fmtDate = (d) => {
  if (!d) return '';
  return new Date(d + (d.includes('T') ? '' : 'T00:00:00'))
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

// Short date: "Feb 12"
export const fmtShort = (d) => {
  if (!d) return '';
  return new Date(d + (d.includes('T') ? '' : 'T00:00:00'))
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

// ISO date string for today
export const todayISO = () => new Date().toISOString().split('T')[0];

// Get start of current week (Sunday)
export const weekStartISO = () => {
  const now = new Date();
  const d = new Date(now);
  d.setDate(now.getDate() - now.getDay());
  return d.toISOString().split('T')[0];
};
